import script from "./table-service-health-kpi.vue?vue&type=script&setup=true&lang=js"
export * from "./table-service-health-kpi.vue?vue&type=script&setup=true&lang=js"

import "./table-service-health-kpi.vue?vue&type=style&index=0&id=271e9d6a&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271e9d6a"]])

export default __exports__